import dayjs from 'dayjs';

export const DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';

export function formatEpochDateTime(value, options = {}) {
  const { emptyValue = '-' } = options;

  if (value === null || value === undefined || value === '') {
    return emptyValue;
  }

  const epochSeconds = Number(value);
  if (Number.isNaN(epochSeconds)) {
    return emptyValue;
  }

  const parsed = dayjs.unix(epochSeconds);
  if (!parsed.isValid()) {
    return emptyValue;
  }

  return parsed.format(DATE_TIME_FORMAT);
}

export function formatCurrentPeriod(start, end, options = {}) {
  const { emptyValue = '-' } = options;
  const formattedStart = formatEpochDateTime(start, { emptyValue });
  const formattedEnd = formatEpochDateTime(end, { emptyValue });

  if (formattedStart === emptyValue && formattedEnd === emptyValue) {
    return emptyValue;
  }

  return `${formattedStart} to ${formattedEnd}`;
}
